<template>
  <div>
    <div class="bgBox">
      <div class="mainBox">
        <div class="leftBox">
          <img src="../../assets/img/logo.png" alt="" />
          <div class="logo_title">建造云</div>
          <div class="link">
            <router-link to="/" class="link_title"> 首页 </router-link>
            <div class="link_title" @mouseover="appListShow()">应用场景</div>
            <div class="link_title" @mouseover="technologyListShow()">核心技术</div>
            <div class="link_title" @mouseover="scientificListShow()">科研资源</div>
            <router-link to="/newsInformation" class="link_title">新闻资讯</router-link>
            <router-link to="/partnership" class="link_title">合作关系</router-link>
          </div>
        </div>
        <div class="rightBox">
          <input class="seach" type="text" v-model="seachInput" placeholder="请输入" />
          <i class="el-icon-search icon"></i>
          <div class="right_title">
            <router-link to="/login">登录</router-link>|
            <router-link to="/login">注册</router-link>
          </div>
          <router-link to="/selfService" class="bth_box">自助体验 ></router-link>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="list_min" v-show="appShow" @mouseleave="listClose()">
      <div class="list_box">
        <div class="left">
          <div class="title">智慧建造与运维云平台</div>
          <div class="left_inc">
            面向不同类型基础设施，提供多维度应用场景实现的成果、技术、功能、界面、案例、团队
          </div>
        </div>
        <div class="right">
          <div class="title">应用场景</div>
          <div class="app_scene">
            <router-link to="/appScene" class="scene" @click.native="listClose()">智慧道路桥梁</router-link>
            <router-link to="/appIndustry" class="scene" @click.native="listClose()">智慧产业园区</router-link>
          </div>
          <div class="app_scene">
            <router-link to="/appBuilding" class="scene" @click.native="listClose()">智慧绿色建筑</router-link>
            <router-link to="/appTraffic" class="scene" @click.native="listClose()">智慧交通设施</router-link>
          </div>
          <div class="app_scene">
            <router-link to="/appUnderground" class="scene" @click.native="listClose()">智慧地下空间</router-link>
            <router-link to="/appEnergy" class="scene" @click.native="listClose()">智慧能源设施</router-link>
          </div>
          <div class="app_scene">
            <router-link to="/appcountry" class="scene" @click.native="listClose()">智慧城乡设施</router-link>
            <div class="scene" style="pointer-events: none;color:#A6ABA8">智慧交通设施</div>
          </div>
        </div>
      </div>
    </div>
    <div class="list_min" v-show="technologyShow" @mouseleave="listClose()">
      <div class="list_box">
        <div class="left">
          <div class="title">智能化在线工具</div>
          <div class="left_inc">
            可视化技术、智能化算法、高精尖设备、一体化方案
          </div>
        </div>
        <div class="right">
          <div class="title">核心技术</div>
          <div style="display: flex;justify-content: space-between;">
            <div class="technologybox">
              <div>算法</div>
              <div class="technologyhead">计算机视觉类</div>
              <router-link to="/sonar" class="technologytitle" @click.native="listClose()">
                基于声呐的水下结构大范围检测
              </router-link>
              <router-link to="/uav" class="technologytitle" @click.native="listClose()">
                基于无人机的表观病害识别
              </router-link>
              <div class="technologyhead">大数据分析类</div>
              <router-link to="/bigData_one" class="technologytitle" @click.native="listClose()">
                基于人工智能的工程造价管理
              </router-link>
              <router-link to="/bigData_two" class="technologytitle" @click.native="listClose()">
                基于动态模型的楼宇空调节能算法
              </router-link>
              <router-link to="/bigData_three" class="technologytitle" @click.native="listClose()">
                基于能源用户侧的电压暂降监测分析与溯源
              </router-link>
              <router-link to="/bigData_four" class="technologytitle" @click.native="listClose()">
                异常数据处理
              </router-link>
              <div class="technologyhead">深度学习人工智能</div>
              <router-link to="/intelligence_one" class="technologytitle" @click.native="listClose()">
                基于人工智能算法的交通监控
              </router-link>
              <router-link to="/intelligence_two" class="technologytitle" @click.native="listClose()">
                基于人工智能算法的安全管理
              </router-link>
              <router-link to="/intelligence_three" class="technologytitle" @click.native="listClose()">
                基于人工智能算法的视觉测量
              </router-link>
            </div>
            <div class="technologybox">
              <div>设备</div>
              <div class="technologyhead">检测设备</div>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                声发射探测设备
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                水下检测大视场阵列相机
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                双目相机
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                长大跨结构测量相机链
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                工业相机
              </router-link>
              <div class="technologyhead">操作设备</div>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                大疆M210RTK无人机
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                大疆M300RTK无人机
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                大疆精灵4RTK无人机
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                手持3D扫描仪、数据采集与解调设备
              </router-link>
              <div class="technologyhead">传感器</div>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                水下接触式视觉传感器
              </router-link>
              <router-link to="/equipment" class="technologytitle" @click.native="listClose()">
                嵌入式无线传感开发板
              </router-link>
            </div>
            <div class="technologybox">
              <div>系统</div>
              <div class="technologytitle">
                <a href="https://www.powerseu.com/login" target="_blank">
                  BeSmart智慧能源管理平台
                </a>
              </div>
              <div class="technologytitle">
                <a href="http://47.111.160.95:9090/bm/#/home" target="_blank">
                  智慧农业系统
                </a>
              </div>
              <div class="technologytitle">
                <a href="http://121.196.25.19:7801/lyzgc/pages/dist/index.html#/Home" target="_blank">
                  智慧园区
                </a>
              </div>
              <div class="technologytitle">
                <a href="https://zhuangpei.njsjw.cn/" target="_blank">
                  南京装配式建筑信息服务与监管平台
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list_min" v-show="scientificShow" @mouseleave="listClose()">
      <div class="list_box">
        <div class="left">
          <div class="title">智慧建造与运维的“最强大脑”</div>
          <div class="left_inc">
            将智慧建造与运维研究成果进行转化应用
          </div>
        </div>
        <div class="right">
          <div class="title">科研资源</div>
          <div class="scientific">
            <a href="" target="_blank" style="pointer-events: none">
              东南大学智慧建造与运维国家地方联合工程研究中心
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              智慧建筑材料微结构研究中心
            </a>
            <a href="https://civil.seu.edu.cn/pec/main.psp" target="_blank">
              国家预应力工程技术研究中心
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              东南大学智慧交通基础设施研究所
            </a>
            <a href="https://cpcs.seu.edu.cn/" target="_blank">
              混凝土及预应力混凝土结构教育部重点实验室
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              东鸿智慧城市地下空间科技（南京）有限公司
            </a>
            <a href="https://etcc.seu.edu.cn/" target="_blank">
              能源热转换及其过程测控教育部重点实验室
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              东南大学溧阳研究院
            </a>
            <a href="https://itscenter.seu.edu.cn/" target="_blank">
              智能交通运输系统教育部工程研究中心
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              东博智慧能源研究院有限公司
            </a>
            <a href="https://www.seudongyin.com/#/" target="_blank">
              江苏东印智慧工程技术研究院
            </a>
            <a href="" target="_blank" style="pointer-events: none">
              东南大学-威斯康星大学智能网联交通联合研究院
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      seachInput: "",
      appShow: false,
      technologyShow: false,
      scientificShow: false
    };
  },
  methods: {
    appListShow() {
      this.appShow = true;
      this.technologyShow = false;
      this.scientificShow = false;
    },
    technologyListShow() {
      this.appShow = false;
      this.technologyShow = true;
      this.scientificShow = false;
    },
    scientificListShow() {
      this.appShow = false;
      this.technologyShow = false;
      this.scientificShow = true;
    },
    listClose() {
      this.appShow = false;
      this.technologyShow = false;
      this.scientificShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.bgBox {
  width: 100%;
  min-width: 1200px;
  height: 64px;
  background-color: #29252a;
  .mainBox {
    width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
    line-height: 64px;
    display: flex;
    justify-content: space-between;
    .leftBox {
      display: flex;
      img {
        width: 42px;
        height: 42px;
        margin-top: 11px;
        margin-right: 10px;
      }
      .logo_title {
        font-weight: 100;
        font-size: 28px;
        color: #ffffff;
        margin-right: 10px;
      }
      .link {
        display: flex;
        .link_title {
          width: 100px;
          text-align: center;
          font-family: "PingFangSC-Ultralight", "PingFang SC Ultralight",
            "PingFang SC", sans-serif;
          font-weight: 100;
          font-size: 17px;
          color: #ffffff;
          &:hover {
            color: rgb(253, 208, 0);
            cursor: pointer;
          }
        }
      }
    }
    .rightBox {
      display: flex;
      color: #ffffff;
      .seach {
        width: 150px;
        height: 32px;
        margin-top: 15px;
        background: transparent;
        border-radius: 16px;
        border: 1px solid rgba(127, 127, 127, 1);
        outline: 0;
        color: white;
        padding: 0 28px 0 10px;
      }
      .icon {
        position: relative;
        left: -27px;
        top: 24px;
      }
      .right_title {
        height: 64px;
        margin: 0 20px;
        a {
          font-weight: 100;
          font-style: normal;
          font-size: 14px;
          margin: 0 5px;
          height: 64px;
          color: white;
          &:hover {
            color: rgb(253, 208, 0);
            cursor: pointer;
          }
        }
      }
      .bth_box {
        width: 100px;
        min-width: 100px;
        height: 32px;
        margin-top: 16px;
        line-height: 32px;
        text-align: center;
        background-color: rgba(253, 208, 0, 1);
        font-weight: 100;
        color: #000000;
      }
    }
  }
}
.list_min {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  .list_box {
    width: 1200px;
    min-height: 500px;
    display: flex;
    z-index: 999999;
    box-shadow: 4px 0px 12px 5px rgba(0, 0, 0, 0.2);
    position: absolute;
    .left {
      width: 30%;
      background-color: #587558;
      color: white;
      .title {
        width: 255px;
        margin: 0 auto;
        padding: 40px 0;
        font-size: 18px;
      }
      .left_inc {
        width: 255px;
        margin: 0 auto;
        font-weight: 200;
        line-height: 29px;
        font-size: 14px;
      }
    }
    .right {
      width: 70%;
      background-color: white;
      padding: 40px 20px 40px 40px;
      box-sizing: border-box;
      .title {
        font-weight: 200;
        font-size: 20px;
        margin-bottom: 30px;
      }
      // 应用场景
      .app_scene {
        display: flex;
        .scene {
          margin: 0 150px 10px 0;
          font-weight: 200;
          font-size: 14px;
          font-style: normal;
          color: #231815;
          cursor: pointer;
          &:hover {
            color: #6da759;
          }
        }
      }
      //技术
      .technologybox {
        line-height: 28px;
        .technologyhead {
          font-weight: 500;
          color: #aaa4a1;
          font-size: 14px;
          margin-top: 10px;
        }
        .technologytitle {
          display: block;
          font-weight: 200;
          color: #231815;
          font-size: 14px;
          margin-left: 10px;
          cursor: pointer;
          &:hover {
            color: #6da759;
          }
        }
      }
      //scientific
      .scientific {
        display: flex;
        flex-wrap: wrap;
        a {
          width: 50%;
          font-weight: 200;
          font-size: 14px;
          line-height: 32px;
          &:hover {
            color: #6da759;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/headTop.vue